import React from 'react';

import QuizCountdown from 'containers/Quiz/Countdown';
import QuizSignUp from 'containers/Quiz/SignUp';

import LoversResults from '../LoversResults';

import Gender from './Gender';
import Length from './Length';
import Scenario from './Scenario';
import Sounds from './Sounds';
import Tone from './Tone';

const QUIZ_ID = 'lovers-onboarding';

export const QUIZ_ROUTE = 'alt/lovers-onboarding';
export const LOVERS_TRACKING = QUIZ_ID;

export const QUIZ_STEPS = [
  () => <Gender />,
  () => <Tone />,
  () => <Scenario />,
  () => <Sounds />,
  () => <Length />,
  () => <QuizCountdown trackingUrl={`${QUIZ_ROUTE}/countdown`} />,
  () => <QuizSignUp pathPrefix={QUIZ_ID} />,
  () => <LoversResults />,
];
